export const NDP6_TAXONOMY = {
  pillars: [
    {
      id: 1,
      name: "Economic Advancement",
      thematicAreas: [
        { id: 1.1, name: "Infrastructure Development", focusAreas: ["Roads & Bridges", "Energy Security", "Water Infrastructure"] },
        { id: 1.2, name: "Industrialization", focusAreas: ["Manufacturing", "SME Support", "Mining Value Addition"] }
      ]
    },
    {
      id: 2,
      name: "Social Transformation",
      thematicAreas: [
        { id: 2.1, name: "Education & Skills", focusAreas: ["Vocational Training", "Primary Education", "Higher Education"] },
        { id: 2.2, name: "Health & Wellness", focusAreas: ["Universal Health Coverage", "Hospital Infrastructure", "Public Health"] }
      ]
    },
    {
      id: 3,
      name: "Environmental Sustainability",
      thematicAreas: [
        { id: 3.1, name: "Climate Action", focusAreas: ["Renewable Energy", "Conservation", "Disaster Management"] }
      ]
    },
    {
      id: 4,
      name: "Good Governance",
      thematicAreas: [
        { id: 4.1, name: "Public Service Reform", focusAreas: ["Digitalization", "Accountability", "Service Delivery"] }
      ]
    }
  ]
};